'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './code-edit.routes';

export class ActivationCodeEditComponent {
  constructor(ActivationCodeService, Auth, $state, $stateParams, dialogs, StorageService, Upload, $q, Config) {
    'ngInject';

    this.ActivationCodeService = ActivationCodeService;
    this.Auth = Auth;

    this.codeId = $stateParams.id;

    this.dialogs = dialogs;
    this.$state = $state;

    this.groups = Config.getModuleConfig(Config.Modules.SignUp).getActivationCodeGroups() || [];

    this.codeTemplate = {
      code: '',
      description: '',
      payload: {},
      group: '',
      isOneTimeCode: false, // permanent
      meta: {
        creationUser: Auth.getCurrentUserSync()._id,
        active: true
      }
    };

    this.code = angular.copy(this.codeTemplate);

    if (this.codeId) {
      this.ActivationCodeService.get({id: this.codeId}, data => {
        this.code = data;
      }, err => {
        console.log('Could not load activation code from server');
      });
    }
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {

        var actionString = (this.codeId) ? "changed" : "created";

        var dlg = this.dialogs.notify("Success", "The activation code has been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$state.go("activation-code-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      if (this.codeId) {  // Save changes on the current activation code
        this.ActivationCodeService.update({id: this.codeId}, this.code, onSuccess, onError);
      } else { // Create new activation code
        this.ActivationCodeService.save(this.code, onSuccess, onError);
      }
    }
  }

  setPayload() {
    let idx = this.groups.findIndex(item => item.group == this.code.group);

    if (idx !== -1) {
      this.code.payload = this.groups[idx].payload;
    }
  }
}

export default angular.module('conduuApp.activationCodeEdit', [uiRouter])
  .config(routes)
  .component('activationCodeEdit', {
    template: require('./code-edit.html'),
    controller: ActivationCodeEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/activation-code/edit/code-edit.component.js